import { createContext, useContext, useState, ReactNode, JSX } from 'react';

type PrintContextValue = {
  isPrinting: boolean;
  startPrint: () => void;
  endPrint: () => void;
};

const PrintContext = createContext<PrintContextValue | null>(null);

export const PrintProvider = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const [isPrinting, setIsPrinting] = useState(false);

  const startPrint = (): void => setIsPrinting(true);
  const endPrint = (): void => setIsPrinting(false);

  return (
    <PrintContext.Provider value={{ isPrinting, startPrint, endPrint }}>
      {children}
    </PrintContext.Provider>
  );
};

export const usePrintContext = (): PrintContextValue => {
  const ctx = useContext(PrintContext);
  if (!ctx) {
    throw new Error('usePrintContext must be used inside PrintProvider');
  }
  return ctx;
};
